import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://github.com/Briantmorr',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://www.linkedin.com/in/brian-t-morris',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'mailto:brianmorris.tech@gmail.com',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
